/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  makeStyles,
  Button,
  Box,
  Toolbar,
  Typography,
  IconButton,
  CircularProgress,
  TextField,
  withStyles,
  InputAdornment,
  CardContent,
  Grid,
  Card,
} from '@material-ui/core';
import debounce from 'lodash.debounce';

import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import clsx from 'clsx';
import Pagination from '@material-ui/lab/Pagination';
import { CSVLink } from 'react-csv';

import { DynamicDeleteDialogView, DynamicDialogView } from '../index';
import DynamicIcon from '../../Common/DynamicIcon';
import {
  getGradient,
  getindexGradientId,
  InfoWithIconCardWidget,
} from '../CardWidgets/BasicWidgets';

import { filter, get, isEqual } from 'lodash';
import DataCell from './DataCell';
import SMCheckBox from 'components/Common/SMCheckBox';
import { cellStateReducer, initialiseValue } from './TableUtils';
import SMDIalogControl from 'services/SMDialogControl';
import CloseIcon from '@material-ui/icons/Close';
import {
  SMPromptControl,
  SMConfirmDialogControl,
} from 'services/SMDialogControl';
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';
import { clickToPrint } from 'util/misc';
import { sendAmplitudeData } from 'util/amplitude';
import { DateField, DropdownField } from '../../Common/Filters';

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#2896E9',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#2896E9',
    },
  },
})(TextField);
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  container: {
    '&::-webkit-scrollbar': {
      height: 5,
      width: 5,
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CBD1D7',
      borderRadius: 3.5,
    },
    // overflow: 'auto',
    width: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: 7,
    padding: '0px 5px',
  },
  paginationCell: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    border: '0.5px solid #dddddd',
    borderRadius: 5,
    margin: '2.5px',
    minWidth: 30,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableFooterActionButton: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    border: '1px solid #dddddd',
    minWidth: 30,
    height: 30,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    margin: '2.5px',
  },
  tableFooter: {
    paddingTop: 20,
    paddingBottom: 10,
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: '1px solid #e0e0e0',
  },
  row: {
    backgroundColor: '#ffffff',
    '&$selected': {
      backgroundColor: '#e7e6fc',
    },
    '&$selected:hover': {
      backgroundColor: '#e7e6fc',
    },
    borderCollapse: 'collapse',
  },
  hover: {},
  selected: {},
  toolbarRoot: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'base-line',
  },
  toolbarTitle: {
    flex: '1 1 100%',
  },
  searchBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #dddddd',
    borderRadius: 4,
    overflow: 'hidden',
    paddingLeft: 15,
    backgroundColor: 'white',
    height: 30,
  },
  searchButton: {
    background: 'transparent',
    borderRadius: 0,
    boxShadow: 'none',
    paddingRight: 5,
    height: 'inherit',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  gradientCard: {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0px 1.5px 10px #0000002d',
    borderRadius: 7,
    opacity: '1',
    minWidth: '190px',
    height: '80px',
  },
  gradientCardContent: {
    paddingLeft: 20,
  },
  gradientCardTitle: {
    textAlign: 'left',
    letterSpacing: '0px',
    fontWeight: 'bolder',
    color: '#0D2965',
  },
  gradientCardSubtitle: {
    textAlign: 'left',
    letterSpacing: '0px',
    color: '#898989',
    fontWeight: 'bolder',
  },
  gradientIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '8%',
    height: '100%',
    borderTopRightRadius: 7,
    borderBottomRightRadius: 7,
  },
  filterContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 40,
    marginRight: 10,
  },
  filterBox: {
    display: 'flex',
    border: '1px solid #E2E2E2',
    borderRadius: 5,
    color: '#898989',
    height: 'inherit',
  },
  clearButton: {
    border: '1px solid #E2E2E2',
    fontSize: '12px',
    borderRadius: 5,
    color: '#898989ff',
    marginLeft: 10,
    height: 'inherit',
  },
  searchField: {
    border: 'none',
    height: '100%',
    outline: 'none',
  },
  dropdown: {
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  date: {
    color: 'black',
  },
  tableCell: {
    padding: 0,
    borderCollapse: 'collapse',
    backgroundColor: '#00000000',
    // verticalAlign: 'top',
  },
  cellContainer: {
    marginTop: '12px',
    marginBottom: '12px',
  },
  iconButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  errorBlock: {
    backgroundColor: '#f5f5f5',
    color: '#888888',
    height: 300,
    width: '100%',
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  popper: {
    zIndex: theme.zIndex.modal,
  },
  borderedField: {
    background: '#f9f9f9',
    flex: 1,
    border: '1px solid #C4C4C4',
    borderRadius: 4,
    fontSize: '1rem',
    padding: '9px 18px',
    cursor: 'pointer',
    color: '#909090',
    '&:hover': { borderColor: '#000000' },
  },
  borderedFieldMobile: {
    background: '#f9f9f9',
    flex: 1,
    border: '1px solid #C4C4C4',
    borderRadius: 4,
    fontSize: '14px',
    padding: '2px 16px',
    cursor: 'pointer',
    color: '#909090',
    '&:hover': { borderColor: '#000000' },
  },
}));

const aggregateEnabled = (aggregators) => {
  const { searchEnabled, filter, numberOfPages, filters } = aggregators;
  return !!(searchEnabled || filter || numberOfPages || filters);
};

function PaginationBlock(props) {
  const classes = useStyles();
  return (
    <button
      variant="contained"
      color="primary"
      onClick={props.onClick}
      className={classes.paginationCell}
    >
      {props.children}
    </button>
  );
}

const ScoreCard = ({
  // TODO Make this to library [handleChange is now handleRowChange] all over this ScoreCard
  handleChange,
  row,
  column,
  preview,
  index,
  rightSideBar,
}) => {
  const [rowData, setRowData] = React.useState(row);
  const classes = useStyles();

  const updateScore = (optionId, score) => {
    const updatedOptions = (rowData[column.key].choices || []).map(
      (currentOption) => {
        if (currentOption.id === optionId) {
          currentOption.score = score;
        }
        return currentOption;
      }
    );
    setRowData({ ...rowData, choices: updatedOptions });
    handleChange(column, rowData, { choices: updatedOptions });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Box p={1} display="flex" justifyContent="flex-end">
        <IconButton
          onClick={() => {
            rightSideBar.setMenuOpen(false);
            setTimeout(() => {
              rightSideBar.setMenuComponent(undefined);
            }, 200);
          }}
        >
          <DynamicIcon iconId={158} style={{ width: 12 }} />
        </IconButton>
      </Box>
      <Box px={4} overflow="auto">
        <Typography
          variant="h6"
          style={{
            fontWeight: '700',
            color: '#505050',
          }}
        >
          SCORE RESPONSES
        </Typography>
        <Typography style={{ color: '#747474', paddingTop: 20 }}>
          TASK ACTION
        </Typography>
        <div
          style={{
            display: 'flex',
            padding: '20px 0px',
            maxWidth: 300,
            borderBottom: '1px solid #e0e0e0',
          }}
        >
          <Typography style={{ color: '#747474', marginRight: 16 }}>
            {index}.
          </Typography>
          <Typography
            style={{
              wordWrap: 'break-word',
              overflow: 'hidden',
              whiteSpace: 'pre-wrap',
              color: '#747474',
            }}
          >
            {row[(preview || {}).titleColumnKey].value}
          </Typography>
        </div>
        <Typography style={{ color: '#a5a5a5', padding: '20px 0px' }}>
          RESPONSE
        </Typography>
        <TableContainer elevation={2}>
          <Table
            className={classes.table}
            aria-label="simple table"
            stickyHeader={true}
            style={{
              border: '2px solid #e0e0e0',
              borderCollapse: 'collapse',
              borderRadius: 5,
              width: 100,
              maxWidth: 100,
            }}
          >
            {(rowData[column.key].choices || []).map((option, index) => (
              <TableRow
                key={rowData.id}
                classes={{
                  root: classes.rowData,
                }}
              >
                <TableCell
                  key={index}
                  style={{
                    minWidth: 150,
                    maxWidth: 170,
                    borderRight: '1px solid #e0e0e0',
                  }}
                >
                  <Box
                    px={2}
                    py={1}
                    style={{
                      background: getGradient(option.gradientId) || 'e8e8e8',
                      color: 'white',
                      marginRight: 16,
                      borderRadius: 5,
                      textAlign: 'center',
                    }}
                  >
                    {option.title}
                  </Box>
                </TableCell>
                <TableCell
                  key={index}
                  style={{
                    minWidth: 150,
                    maxWidth: 170,
                    borderRight: '1px solid #e0e0e0',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                    }}
                  >
                    <Typography variant="subtitle2">Score:</Typography>
                    <input
                      type="text"
                      style={{
                        border: 'none',
                        background: '#F7F7F7 0% 0% no-repeat padding-box',
                        borderRadius: 5,
                        color: '#898989',
                        textAlign: 'center',
                        padding: 5,
                        maxWidth: 60,
                      }}
                      placeholder="Enter Score"
                      value={option.score}
                      onChange={(e) => {
                        updateScore(option.id, e.target.value);
                      }}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
};

const TableInfoContainer = (props) => {
  return (
    <div style={{ display: 'flex', width: '100%' }}>
      {props.tableInfo &&
        props.tableInfo.map((info) => (
          <div style={{ marginRight: 25, marginBottom: 25 }}>
            <InfoWithIconCardWidget
              title={info.title}
              subtitle={info.subtitle}
              gradientId={info.gradientId}
              iconId={info.iconId}
              infoIcon={info.infoIcon}
              titleColor={info.titleColor}
            />{' '}
          </div>
        ))}
    </div>
  );
};

const TableFiltersAndSearchContainer = (props) => {
  const {
    filters,
    numSelected,
    searchString,
    setSearchString,
    searchEnabled,
    formFields,
  } = props;
  const [localFilters, setLocalFilters] = React.useState({});
  const [localSearchString, setLocalSearchString] = React.useState(
    searchString || ''
  );
  React.useEffect(() => {
    props.selectedFilters &&
      Object.keys(props.selectedFilters).length > 0 &&
      setLocalFilters({ ...props.selectedFilters });
  }, [props.selectedFilters]);

  const selectFilter = (key, value) => {
    props.setSelectedFilters({
      ...(props.selectedFilters || {}),
      [key]: value,
    });
  };

  const removeFilter = (filter) => {
    let res = {};
    for (let key in localFilters) {
      if (key != filter.key) res[key] = localFilters[key];
    }
    setLocalFilters({ ...res });
    Object.keys(props.selectedFilters).length > 0 &&
      props.setSelectedFilters({ ...res });
  };
  function useDebounce(callback, delay) {
    const debouncedFn = React.useCallback(
      debounce((...args) => callback(...args), delay),
      [delay]
    );
    return debouncedFn;
  }

  const search = (value) => {
    setSearchString(value);
  };
  const debouncedSearch = useDebounce((value) => {
    search(value);
  }, 800);

  const handleSearch = (value) => {
    debouncedSearch(value);
  };

  return (
    <>
      {(searchEnabled || filters || formFields) && (
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            height: 70,
          }}
        >
          {numSelected == 0 && searchEnabled ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
              }}
            >
              <CssTextField
                placeholder="Search"
                variant="outlined"
                size="small"
                value={localSearchString}
                onChange={(e) => {
                  setLocalSearchString(e.target.value);
                  handleSearch(e.target.value);
                }}
                style={{ padding: 8 }}
                InputProps={{
                  style: {
                    background: '#f9f9f9',
                    width: '25vw',
                  },
                  disableUnderline: true,
                  endAdornment: (
                    <InputAdornment>
                      <SearchOutlinedIcon
                        cursor={'pointer'}
                        style={{ color: '#949494' }}
                      />
                      {localSearchString && (
                        <CloseOutlinedIcon
                          cursor={'pointer'}
                          onClick={() => {
                            props.resetFields();
                            setLocalSearchString('');
                          }}
                          style={{ color: '#949494' }}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          ) : null}

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-start',
              flexGrow: 1,
              paddingRight: filters && 8,
              paddingLeft: 8,
            }}
          >
            {formFields && (
              <>
                {formFields.map((field) =>
                  field.type == 'dropdown' ? (
                    <DropdownField
                      field={field}
                      handleChange={props.handleFormUpdate}
                    />
                  ) : null
                )}
              </>
            )}
            {filters && (
              <>
                {filters.map((filter) =>
                  filter.type == 'dropdown' ? (
                    <DropdownField
                      removeFilter={removeFilter}
                      localFilters={localFilters}
                      setLocalFilters={setLocalFilters}
                      field={filter}
                      selectedFilters={props.selectedFilters}
                      setSelectedFilters={props.setSelectedFilters}
                    />
                  ) : filter.type == 'date' ? (
                    <DateField
                      removeFilter={removeFilter}
                      localFilters={localFilters}
                      setLocalFilters={setLocalFilters}
                      field={filter}
                      selectedFilters={props.selectedFilters}
                      setSelectedFilters={props.setSelectedFilters}
                    />
                  ) : null
                )}
                <div
                  style={{
                    width: 40,
                    height: 40,
                    background: '#f9f9f9',
                    margin: 10,
                  }}
                >
                  <IconButton
                    disableRipple
                    style={{ width: 40, height: 40, background: '#f9f9f9' }}
                  >
                    <DynamicIcon
                      iconId={
                        Object.keys(props.selectedFilters).length > 0
                          ? 162
                          : 160
                      }
                      style={{ height: 20, width: 20 }}
                    />
                  </IconButton>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const TableFilterContainer = (props) => {
  const { filters, filter, responseAwaited, setResponseAwaited } = props;
  const [localFilters, setLocalFilters] = React.useState({});
  const selectFilter = (key, value) => {
    props.setSelectedFilters({
      ...(props.selectedFilters || {}),
      [key]: value,
    });
  };
  const classes = useStyles();
  return (
    <div style={{ width: '100%' }}>
      {filter && (
        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              padding: 24,
            }}
          >
            <Grid container spacing={5}>
              {(filter.items || []).map((curFilter, index) => (
                <Box p={1}>
                  <Grid item>
                    <Card
                      key={index}
                      className={classes.gradientCard}
                      onClick={() => {
                        setResponseAwaited(true);
                        !responseAwaited &&
                          selectFilter(filter.key, curFilter.value);
                      }}
                      style={{
                        marginRight: 40,
                        cursor: responseAwaited ? 'default' : 'pointer',
                        ...(props.selectedFilters[filter.key] ===
                        curFilter.value
                          ? { border: '2.5px solid #7467F0' }
                          : { border: '0.5px solid #c2c2c2' }),
                      }}
                    >
                      <CardContent
                        className={classes.gradientCardContent}
                        style={{ width: '100%' }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            justifyContent: 'space-around',
                            flexDirection: 'column',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              width: '100%',
                              alignItems: 'flex-start',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Typography
                              className={classes.gradientCardSubtitle}
                              style={{
                                width: '100%',
                                fontSize: '14px',
                                fontWeight: 'bold',
                              }}
                            >
                              {curFilter.subtitle}
                            </Typography>
                            {props.selectedFilters[filter.key] ===
                              curFilter.value && (
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  props.setSelectedFilters([]);
                                }}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: 20,
                                  height: 20,
                                  marginTop: -2,
                                  marginRight: -8,
                                }}
                              >
                                <CloseIcon
                                  style={{
                                    width: 16,
                                    height: 16,
                                    color: '#6D6CEF',
                                    fontWeight: 'bolder',
                                  }}
                                />
                              </IconButton>
                            )}
                          </div>
                          <Typography
                            className={classes.gradientCardTitle}
                            style={{ fontSize: '20px', fontWeight: 'bold' }}
                          >
                            {curFilter.title}
                          </Typography>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                </Box>
              ))}
            </Grid>
          </div>
        </div>
      )}
    </div>
  );
};

const EnhancedTableToolbar = (props) => {
  const {
    exportTable,
    csvEntities,
    csvHeaders,
    numSelected,
    aggregateActions,
    searchString,
    setSearchString,
    deeplinkHandler,
    searchEnabled,
    tableActions,
    formState,
    pseudoFormState,
    tableKey,
    addRowEnabled,
    addingRow,
    addRow,
    setAddingRow,
    cancelAddRow,
    refreshButton,
    fetchRows,
    refreshTable,
    progressBar,
    clickedActionButton,
    setClickedActionButton,
    clickedAggregateButton,
    setClickedAggregateButton,
    responseAwaited,
  } = props;
  const [localSearchString, setLocalSearchString] = React.useState(
    searchString || ''
  );
  const classes = useStyles();

  React.useEffect(() => {
    setLocalSearchString(searchString);
  }, [searchString]);

  return (
    <>
      {numSelected ||
      searchString ||
      (tableActions && tableActions.length > 0) ||
      (aggregateActions && aggregateActions.length > 0) ||
      progressBar ||
      addRowEnabled ? (
        <Toolbar className={clsx(classes.toolbarRoot)}>
          {numSelected > 0
            ? [
                <Typography
                  className={classes.toolbarTitle}
                  color="inherit"
                  variant="subtitle1"
                  component="div"
                >
                  {numSelected} selected
                </Typography>,
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  {(aggregateActions || []).map((action, index) => (
                    <Button
                      disabled={
                        clickedActionButton != -1 ||
                        clickedAggregateButton != -1
                      }
                      style={{
                        background: action.isErrorButton
                          ? `#fa4d5f`
                          : `${action.color || '#233C97'}`,
                        height: 40,
                        maxWidth: 250,
                        borderRadius: 32.5,
                        padding: 0,
                        marginLeft: 5,
                      }}
                      onClick={() => {
                        setClickedAggregateButton(index);
                        deeplinkHandler(
                          action.deep_link,
                          action.apiType,
                          !!tableKey
                            ? { [tableKey]: (formState || {}).rows }
                            : formState
                        );
                      }}
                    >
                      <DynamicIcon
                        iconId={action.iconId}
                        style={{
                          height: 20,
                          width: 20,
                          color: '#ffffff',
                          marginLeft: action.name ? 15 : 0,
                          fontSize: 15,
                        }}
                        insideColoredButton
                      />
                      {action.name && (
                        <div
                          style={{
                            whiteSpace: 'nowrap',
                            marginLeft: 5,
                            marginRight: 15,
                            fontSize: 16,
                            color: '#ffffff',
                          }}
                        >
                          {(clickedAggregateButton === index && (
                            <CircularProgress
                              thickness={5}
                              size={25}
                              style={{ color: '#ffffff', marginTop: 6 }}
                            />
                          )) ||
                            action.name}
                        </div>
                      )}
                    </Button>
                  ))}
                </div>,
              ]
            : null}
          {numSelected === 0 && [
            <div style={{ display: 'flex' }}>
              {exportTable ? (
                <CSVLink
                  headers={csvHeaders}
                  data={csvEntities}
                  filename={`${exportTable.fileName}.csv` || 'export.csv'}
                  style={{ color: 'inherit', textDecoration: 'none' }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      marginRight: 10,
                      background:
                        'transparent linear-gradient(2deg, #2896E9 0%, #7467F0 100%) 0% 0% no-repeat padding-box',
                      color: '#ffffff',
                      paddingLeft: 10,
                      paddingRight: 10,
                      height: 40,
                      maxWidth: 250,
                      borderRadius: 5,
                    }}
                  >
                    <DynamicIcon
                      iconId={932}
                      insideColoredButton
                      style={{
                        marginLeft: 10,
                        height: 20,
                        width: 20,
                        color: '#ffffff',
                        fontSize: 15,
                      }}
                    />
                    <div
                      style={{
                        fontWeight: 'bold',
                        whiteSpace: 'nowrap',
                        marginLeft: 5,
                        marginRight: 10,
                        color: '#ffffff',
                      }}
                    >
                      Export Table
                    </div>
                  </Button>
                </CSVLink>
              ) : (
                <div />
              )}

              {addRowEnabled ? (
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    fontWeight: 'bold',
                    marginRight: 10,
                    background:
                      'transparent linear-gradient(2deg, #2896E9 0%, #7467F0 100%) 0% 0% no-repeat padding-box',
                    color: '#ffffff',
                    paddingLeft: 10,
                    paddingRight: 10,
                    height: 40,
                    maxWidth: 250,
                    borderRadius: 5,
                  }}
                  onClick={addRow}
                >
                  <DynamicIcon
                    iconId={0}
                    insideColoredButton
                    style={{
                      marginLeft: 10,
                      height: 20,
                      width: 20,
                      color: '#ffffff',
                      fontSize: 15,
                    }}
                  />
                  <div
                    style={{
                      fontWeight: 'bold',
                      whiteSpace: 'nowrap',
                      marginLeft: 5,
                      marginRight: 10,
                      color: '#ffffff',
                    }}
                  >
                    Add Row
                  </div>
                </Button>
              ) : (
                <div />
              )}
              {refreshButton ? (
                <Button
                  onClick={() => refreshTable(refreshButton.refreshDeeplink)}
                  variant="contained"
                  color="primary"
                  style={{
                    marginRight: 10,
                    background:
                      'transparent linear-gradient(2deg, #2896E9 0%, #7467F0 100%) 0% 0% no-repeat padding-box',
                    color: '#ffffff',
                    paddingLeft: 10,
                    paddingRight: 10,
                    height: 40,
                    maxWidth: 250,
                    borderRadius: 5,
                  }}
                >
                  <DynamicIcon
                    iconId={930}
                    insideColoredButton
                    style={{
                      marginLeft: 10,
                      height: 20,
                      width: 20,
                      color: '#ffffff',
                      fontSize: 15,
                    }}
                  />
                  <div
                    style={{
                      fontWeight: 'bold',
                      whiteSpace: 'nowrap',
                      marginLeft: 5,
                      marginRight: 10,
                      color: '#ffffff',
                    }}
                  >
                    Refresh
                  </div>
                </Button>
              ) : (
                <div />
              )}
              {progressBar && (
                <div
                  style={{
                    height: '16px',
                    display: 'flex',
                    marginTop: 13,
                    marginLeft: 16,
                    fontWeight: 'bold',
                    alignItems: 'center',
                  }}
                >
                  {progressBar &&
                    progressBar.currentCount &&
                    progressBar.totalCount && (
                      <div
                        style={{
                          width: '300px',
                          height: '80%',
                          background: '#E2E2E2',
                          borderRadius: '5px',
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={{
                            width: `${
                              ((progressBar.currentCount || 0) /
                                (progressBar.totalCount || 100)) *
                              100
                            }%`,
                            background:
                              'transparent linear-gradient(90deg, #2896E9 0%, #1ED2AC 100%) 0% 0% no-repeat padding-box',
                            height: '100%',
                          }}
                        />
                      </div>
                    )}
                  {progressBar.loading ? (
                    <CircularProgress
                      disableShrink={true}
                      size={20}
                      style={{ marginLeft: 10 }}
                    />
                  ) : (
                    progressBar &&
                    progressBar.currentCount &&
                    progressBar.totalCount && (
                      <div
                        style={{
                          marginLeft: 10,
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: '15px',
                            letterSpacing: '0px',
                            color: '#767676',
                            opacity: 1,
                            fontSize: '14px',
                            fontWeight: 'bolder',
                          }}
                        >
                          {progressBar.currentCount || 0} /{' '}
                          {progressBar.totalCount || 100}{' '}
                          {progressBar.title || 'Progress Status'}
                        </Typography>
                      </div>
                    )
                  )}
                </div>
              )}
            </div>,
            tableActions ? (
              <div
                style={{
                  display: 'flex',
                }}
              >
                {(tableActions || []).map((action, index) => (
                  <Button
                    disabled={
                      clickedActionButton !== -1 ||
                      clickedAggregateButton !== -1 ||
                      responseAwaited
                    }
                    variant="contained"
                    color="primary"
                    style={{
                      marginLeft: 10,
                      background: action.isErrorButton
                        ? `#fa4d5f`
                        : `${action.color || '#233C97'}`,
                      color: '#ffffff',
                      paddingLeft: 10,
                      paddingRight: 10,
                      height: 40,
                      maxWidth: 250,
                      borderRadius: 5,
                    }}
                    onClick={() => {
                      setClickedActionButton(index);
                      sendAmplitudeData(`${action.name} Table Action clicked`, {
                        deep_link: action.deep_link,
                        formBody: pseudoFormState,
                        apiType: action.apiType,
                      });
                      deeplinkHandler(
                        action.deep_link,
                        action.apiType,
                        !!tableKey
                          ? { [tableKey]: (pseudoFormState || {}).rows }
                          : pseudoFormState
                      );
                    }}
                  >
                    <DynamicIcon
                      iconId={action.iconId}
                      insideColoredButton
                      style={{
                        height: 20,
                        width: 20,
                        color: '#ffffff',
                        marginLeft: action.name ? 10 : 0,
                        fontSize: 15,
                      }}
                    />
                    {action.name && (
                      <div
                        style={{
                          fontWeight: 'bold',
                          whiteSpace: 'nowrap',
                          marginLeft: 5,
                          marginRight: 10,
                          color: '#ffffff',
                        }}
                      >
                        {(clickedActionButton === index && (
                          <CircularProgress
                            thickness={5}
                            size={25}
                            style={{ color: '#ffffff', marginTop: 6 }}
                          />
                        )) ||
                          action.name}
                      </div>
                    )}
                  </Button>
                ))}
              </div>
            ) : (
              <div />
            ),
          ]}
        </Toolbar>
      ) : null}
    </>
  );
};

const contentSpecificCellStyles = {
  4: { width: 150 },
  2: { minWidth: 420 },
  7: { maxWidth: 200, width: 150 },
  6: { width: 250 },
  5: { minWidth: 250 },
  3: { width: 200, maxWidth: 200 },
  8: { minWidth: 250, maxWidth: 400 },
};

const EnhancedTableHead = (props) => {
  const {
    onSelectAllClick,
    enableMultipleSelect,
    numSelected,
    rowCount,
    columns,
    index,
  } = props;

  return (
    <TableHead>
      {enableMultipleSelect && (
        <TableCell padding="checkbox" style={{ left: 1 }}>
          <Box
            display="flex"
            justifyContent="center"
            style={{ border: '1px solid #ffffff' }}
          >
            <SMCheckBox
              onChange={onSelectAllClick}
              checked={rowCount > 0 && numSelected === rowCount}
              name="checkedB"
              color="primary"
            />
          </Box>
        </TableCell>
      )}
      <TableCell style={{ width: 42, maxWidth: 42, border: 'none' }}>
        <Typography
          style={{
            color: '#8d8d8d',
            fontSize: 16,
          }}
          align="center"
        >
          #
        </Typography>
      </TableCell>
      {(columns || []).map((column, index) => (
        <TableCell
          key={index}
          style={{
            color: '#505050',
            fontSize: 18,
            padding: 0,
            border: 'none',
            ...(get(
              contentSpecificCellStyles,
              [get(column, ['columnContentType', 'columnType'])],
              undefined
            ) || { minWidth: 200, maxWidth: 300 }),
          }}
        >
          <Box
            display="flex"
            style={{
              border: '1px solid #ffffff',
              padding: 16,
              paddingLeft: 30,
            }}
          >
            <Typography style={{ color: '#8d8d8d' }}>
              {column.title +
                `${column.columnContentType.isRequired ? '*' : ''}`}
            </Typography>
          </Box>
        </TableCell>
      ))}
    </TableHead>
  );
};

const previewRenderers = {
  700: ({ type, items }) => (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '100%',
      }}
    >
      {(items || []).map((item, index) => (
        <Box
          display="flex"
          alignItems="center"
          px={3}
          py={1}
          style={{
            background:
              getGradient(item.gradientId || getindexGradientId(index)) ||
              '#f8f8f8',
            boxShadow: '0px 3px 6px #00000029',
            marginRight: 16,
            borderRadius: 5,
            border: 'none',
            margin: 5,
            maxWidth: '100%',
          }}
        >
          <Typography
            style={{
              color: '#ffffff',
              overflow: 'hidden',
              wordWrap: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}
          >
            {`${item.option}${
              !isNaN(item.score) && item.score !== null && item.score !== ''
                ? ` (${item.score})`
                : ''
            }`}
          </Typography>
        </Box>
      ))}
    </div>
  ),
  800: ({ type, items }) => (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '100%',
      }}
    >
      {(items || []).map((item, index) =>
        (item.min !== undefined && item.min !== null && item.min !== '') ||
        (item.max !== undefined && item.max !== null && item.max !== '') ? (
          <Box
            display="flex"
            alignItems="center"
            px={3}
            py={1}
            style={{
              background:
                getGradient(item.gradientId || getindexGradientId(index)) ||
                '#f8f8f8',
              boxShadow: '0px 3px 6px #00000029',
              marginRight: 16,
              borderRadius: 5,
              border: 'none',
              margin: 5,
              maxWidth: '100%',
            }}
          >
            {!isNaN(item.min) && item.min !== null && item.min !== '' && (
              <div
                style={{
                  display: 'flex',
                  marginRight: 7,
                  alignItems: 'center',
                  paddingRight: 2,
                }}
              >
                <ArrowDownward style={{ color: '#ffffff', fontSize: 15 }} />
                <Typography
                  style={{
                    color: '#ffffff',
                    overflow: 'hidden',
                    wordWrap: 'break-word',
                    whiteSpace: 'normal',
                    maxWidth: '100%',
                  }}
                >
                  {item.min}
                </Typography>
              </div>
            )}
            {!isNaN(item.max) && item.max !== null && item.max !== '' && (
              <div
                style={{
                  display: 'flex',
                  marginRight: 7,
                  alignItems: 'center',
                  paddingRight: 2,
                }}
              >
                <ArrowUpward style={{ color: '#ffffff', fontSize: 15 }} />
                <Typography
                  style={{
                    color: '#ffffff',
                    overflow: 'hidden',
                    wordWrap: 'break-word',
                    whiteSpace: 'normal',
                    maxWidth: '100%',
                  }}
                >
                  {item.max}
                </Typography>
              </div>
            )}
            {!isNaN(item.score) && item.score !== null && item.score !== '' && (
              <Typography
                style={{
                  color: '#ffffff',
                  overflow: 'hidden',
                  wordWrap: 'break-word',
                  whiteSpace: 'normal',
                  maxWidth: '100%',
                }}
              >
                {` Score: ${item.score}`}
              </Typography>
            )}
          </Box>
        ) : null
      )}
    </div>
  ),
};

function RowPreviewComponent(props) {
  const RenderComponent = previewRenderers[props.type] || (() => '');

  return <RenderComponent {...props} />;
}

function EnhancedTableCell({ Component, childProps }) {
  const classes = useStyles();
  const cellRef = React.useRef({});

  return (
    <TableCell
      ref={cellRef}
      className={classes.tableCell}
      style={{
        // borderLeft: childProps.index > 0 ? '1px solid #ffffff' : '',
        border: 'none',
        ...(get(
          contentSpecificCellStyles,
          [get(childProps, ['column', 'columnContentType', 'columnType'])],
          undefined
        ) || { minWidth: 200, maxWidth: 300 }),
        background:
          childProps &&
          childProps.column &&
          childProps.column.key &&
          childProps.row
            ? (childProps.row[childProps.column.key] || {}).bgColor
            : null,
      }}
      padding="none"
    >
      <Component
        cellHeight={get(cellRef, ['current', 'offsetHeight'])}
        {...{ ...(childProps || {}) }}
      />
    </TableCell>
  );
}

function PreviewRow({ rowPreview, enableMultipleSelect }) {
  const classes = useStyles();
  return (
    <TableRow>
      {enableMultipleSelect && <TableCell />}
      <TableCell />
      {(rowPreview.contents || []).map((column, index) => {
        return (
          <TableCell
            key={index}
            className={classes.tableCell}
            style={{ height: '100%', padding: 0 }}
          >
            <div
              className={classes.cellContainer}
              style={{
                borderLeft: index > 0 ? '1px solid #cccccc' : 'none',
                paddingLeft: '30px',
                paddingRight: '30px',
                minHeight: 50,
              }}
            >
              <RowPreviewComponent {...(column || {})} />
            </div>
          </TableCell>
        );
      })}
    </TableRow>
  );
}

const previewValidator = {
  700: (content) =>
    (content || []).reduce(
      (isValid, currentSet) => isValid || !!currentSet.option,
      false
    ),
  800: (content) =>
    (content || []).reduce((isValid, currentSet) => {
      return (
        isValid ||
        (!isNaN(currentSet.min) && currentSet.min !== null) ||
        (!isNaN(currentSet.max) && currentSet.max !== null)
      );
    }, false),
};

const ExtendedTableRow = React.memo(
  ({
    row,
    columns,
    isItemSelected,
    newRowId,
    style,
    enableMultipleSelect,
    handleClick,
    index,
    preview,
    totalRows,
    pseudoFormState,
    handleRowChange,
    rightSideBar,
    handleDeeplink,
    handleDeepLinkFunction,
    baseDeepLink,
    rowKey,
    fetchRows,
    setMessage,
    handlePaste,
    addingRow,
    selected,
    currentPage,
    rowsPerPage,
  }) => {
    const [rowPreview, setRowPreview] = React.useState({
      available: false,
      contents: new Array((columns || []).length).fill({}),
    });

    const rowRef = React.useRef({});

    const setPreview = (index, content) => {
      const newRowPreview = [...rowPreview.contents];
      newRowPreview[index] = !isEqual(content, {})
        ? { ...(newRowPreview[index] || {}), ...content }
        : {};
      setRowPreview({
        available:
          !(
            newRowPreview.filter((column) => isEqual(column, {})).length ===
            columns.length
          ) &&
          newRowPreview.filter((cell) => !!previewRenderers[cell.type])
            .length !== 0 &&
          (previewValidator[content.type] || (() => {}))(content.items),
        contents: newRowPreview,
      });
    };

    React.useEffect(() => {
      if (addingRow && index === (totalRows || 0) - 1 && index !== 0) {
        rowRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, [addingRow]);

    const classes = useStyles();

    return (
      <>
        <TableRow
          ref={rowRef}
          key={row.id}
          selected={isItemSelected}
          // role='checkbox' TODO
          classes={{
            root: classes.row,
            selected: classes.selected,
            hover: classes.hover,
          }}
          style={{
            background:
              row.color || (!isItemSelected && index % 2 == 0 && '#f9f9f9'),
            ...(newRowId === row.id ? style : {}),
          }}
        >
          {enableMultipleSelect && (
            <TableCell
              padding="checkbox"
              style={{ verticalAlign: 'center', border: 'none' }}
            >
              <Box
                display="flex"
                justifyContent="center"
                className={classes.cellContainer}
              >
                <SMCheckBox
                  checked={isItemSelected}
                  color="primary"
                  onClick={() => handleClick(row.id)}
                />
              </Box>
            </TableCell>
          )}
          <TableCell style={{ width: 42, maxWidth: 42, border: 'none' }}>
            <Typography
              style={{
                color: '#707070',
                fontSize: 14,
                fontWeight: 'bold',
              }}
              align="center"
            >
              {rowsPerPage
                ? rowsPerPage * (currentPage - 1) + index + 1
                : index + 1}
            </Typography>
          </TableCell>
          {(columns || []).map((column, columnIndex) => (
            <EnhancedTableCell
              key={`${row.id}-${column.key}`}
              Component={DataCell}
              childProps={{
                pseudoFormState: pseudoFormState,
                column,
                row,
                rowState:
                  pseudoFormState.rows.find(
                    (currentRow) => currentRow.id === row.id
                  ) || {}, // TODO use Lodash here
                handleRowChange,
                rightSideBar: rightSideBar,
                // TODO Don't know why preview is being sent here
                preview: preview,
                // TODO Don't know why index is being passed
                index: columnIndex,
                rowIndex: index,
                setPreview,
                handleDeeplink,
                handleDeepLinkFunction,
                baseDeepLink,
                rowKey,
                fetchRows,
                columns,
                selected,
                setMessage,
                handlePaste,
              }}
            />
          ))}
        </TableRow>
        {rowPreview.available && (
          <PreviewRow
            rowPreview={rowPreview}
            enableMultipleSelect={enableMultipleSelect}
          />
        )}
      </>
    );
  },
  (prevProps, currentProps) => {
    const prevRowState =
      prevProps.pseudoFormState.rows.find(
        (currentRow) => currentRow.id === currentProps.row.id
      ) || {};
    const currentRowState =
      currentProps.pseudoFormState.rows.find(
        (currentRow) => currentRow.id === currentProps.row.id
      ) || {};
    return (
      (Object.keys(currentRowState || {}) || []).reduce(
        (unchanged, attribute) => {
          return (
            unchanged &&
            isEqual(
              (prevRowState || {})[attribute],
              (currentRowState || {})[attribute]
            )
          );
        },
        true
      ) &&
      prevProps.isItemSelected === currentProps.isItemSelected &&
      isEqual(prevProps.selected, currentProps.selected) &&
      isEqual(prevProps.lastUpdated, currentProps.lastUpdated) &&
      ((prevProps || {}).rows || []).length ===
        ((currentProps || {}).rows || []).length
    );
  }
);

function ErrorView(props) {
  const classes = useStyles();
  return (
    <div className={classes.errorBlock}>
      <span>{props.errorMessage}</span>
    </div>
  );
}

function TableErrorView(props) {
  return (
    <TableRow>
      <TableCell colSpan={props.colSpan}>
        <ErrorView {...props} />
      </TableCell>
    </TableRow>
  );
}
const LoadingSheet = (props) => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: '#ffffff00',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(props.containerStyle || {}),
      }}
    >
      <CircularProgress />
    </div>
  );
};

export function TableWidget(props) {
  const classes = useStyles();
  const [rows, setRows] = React.useState(props.rows || []);
  const [columns, setColumns] = React.useState(props.columns || []);
  // formState will be used when multiple select submit or table level submit comes to play
  const [formState, setFormState] = React.useState({});
  const [pseudoFormState, setPseudoFormState] = React.useState({
    rows: (rows || []).map((row) =>
      (columns || []).reduce(
        (rowState, currentColumn) => ({
          ...rowState,
          ...cellStateReducer(row, currentColumn),
          id: row.id,
        }),
        {}
      )
    ),
  });
  const [currentPage, setPage] = React.useState(props.currentPage || 1);
  const { handleDeeplink, progressStatusDeepLink } = props;
  const [selected, setSelected] = React.useState([]);
  const [selectedFilters, setSelectedFilters] = React.useState(
    (props.filter &&
      props.filter.selected && { [props.filter.key]: props.filter.selected }) ||
      {}
  );
  const [searchString, setSearchString] = React.useState('');
  const [dialogDeeplink, setDialogDeeplink] = React.useState('');
  const [newRowId, setNewRowId] = React.useState('');
  const [deleteDeeplink, setDeleteDeeplink] = React.useState('');
  const [style, setStyle] = React.useState({ backgroundColor: '#e7e6fc' });
  const [refresh, setRefresh] = React.useState(false);
  const [addingRow, setAddingRow] = React.useState(false);
  const [newRowIndex, setNewRowIndex] = React.useState(null);
  const [selectedFile, setSelectedFile] = React.useState({});
  const [lastUpdated, setLastUpdated] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [progressBar, setProgressBar] = React.useState(
    props.progressBar || null
  );
  const [responseAwaited, setResponseAwaited] = React.useState(false);
  const [clickedActionButton, setClickedActionButton] = React.useState(-1);
  const [clickedAggregateButton, setClickedAggregateButton] =
    React.useState(-1);
  const [numberOfPages, setNumberOfPages] = React.useState(
    props.numberOfPages || 0
  );
  const fileInputRef = React.useRef({});
  const blankRowGenerator = (id) => ({
    ...(columns || []).reduce(
      (row, currentColumn) => ({
        ...row,
        [currentColumn.key]: {
          value: initialiseValue(currentColumn),
        },
      }),
      {}
    ),
    id,
  });
  React.useEffect(() => {
    props.progressBar && setProgressBar(props.progressBar);
  }, [props.progressBar]);
  const refreshTable = (deeplink) => {
    setLoading(true);
    handleDeeplink(deeplink).then((data) => {
      setResponseAwaited(false);
      data &&
        setNumberOfPages(
          data.numberOfPages ||
            (
              get(data, ['sections', '0', 'tables'], []).find(
                (table) => table.id === props.id
              ) || {}
            ).numberOfPages == 0
            ? 1
            : (
                get(data, ['sections', '0', 'tables'], []).find(
                  (table) => table.id === props.id
                ) || {}
              ).numberOfPages || numberOfPages
        );

      data && props.setTables(get(data, ['sections', '0', 'tables'], []));
      setLoading(false);
    });
  };

  const fetchRows = (deeplink, pageIndex) => {
    setLoading(true);
    handleDeeplink(deeplink).then((data) => {
      // setTableData({ ...tableData, rows: data.rows });
      // data && props.setTables( get(data, ['sections', '0', 'tables'], []));
      // data &&
      //   setTableActions(
      //     data.tableActions ||
      //       (
      //         get(data, ['sections', '0', 'tables'], []).find(
      //           (table) => table.id === props.id
      //         ) || {}
      //       ).tableActions ||
      //       tableActions
      //   );
      data &&
        setRows(
          data.rows ||
            (
              get(data, ['sections', '0', 'tables'], []).find(
                (table) => table.id === props.id
              ) || {}
            ).rows ||
            rows
        );
      data &&
        refreshFormState(
          data.rows ||
            (
              get(data, ['sections', '0', 'tables'], []).find(
                (table) => table.id === props.id
              ) || {}
            ).rows,
          columns
        );
      setLastUpdated(Date.now());
      data &&
        setPage(
          data.currentPage ||
            (
              get(data, ['sections', '0', 'tables'], []).find(
                (table) => table.id === props.id
              ) || {}
            ).currentPage ||
            (pageIndex !== undefined && pageIndex) ||
            currentPage
        );

      data &&
        setNumberOfPages(
          data.numberOfPages ||
            (
              get(data, ['sections', '0', 'tables'], []).find(
                (table) => table.id === props.id
              ) || {}
            ).numberOfPages == 0
            ? 1
            : (
                get(data, ['sections', '0', 'tables'], []).find(
                  (table) => table.id === props.id
                ) || {}
              ).numberOfPages || numberOfPages
        );

      // data &&
      //   setRefreshButton(
      //     data.refreshButton ||
      //       (
      //         get(data, ['sections', '0', 'tables'], []).find(
      //           (table) => table.id === props.id
      //         ) || {}
      //       ).refreshButton ||
      //       refreshButton
      //   );

      // data &&
      //   setAggregateActions(
      //     data.aggregateActions ||
      //       (
      //         get(data, ['sections', '0', 'tables'], []).find(
      //           (table) => table.id === props.id
      //         ) || {}
      //       ).aggregateActions ||
      //       aggregateActions
      //   );
      // data &&
      //   setProgressBar(
      //     data.progressBar ||
      //       (
      //         get(data, ['sections', '0', 'tables'], []).find(
      //           (table) => table.id === props.id
      //         ) || {}
      //       ).progressBar
      //   );
      // data &&
      //   setCheckProgress(
      //     data.checkProgress ||
      //       (
      //         get(data, ['sections', '0', 'tables'], []).find(
      //           (table) => table.id === props.id
      //         ) || {}
      //       ).checkProgress
      //   );
      setLoading(false);
    });
  };

  const isSelected = (id) => selected.includes(id);

  const handleClick = (rowId) => {
    let newSelected = [];

    if (selected.includes(rowId)) {
      newSelected = selected.filter((selectedValue) => selectedValue !== rowId);
    } else {
      newSelected = [...selected, rowId];
    }

    setSelected(newSelected);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((row) => row.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const refreshFormState = (rows, columns, preCalculatedState) => {
    setPseudoFormState(
      preCalculatedState || {
        rows: (rows || []).map((row) =>
          (columns || []).reduce(
            (rowState, currentColumn) => ({
              ...rowState,
              ...cellStateReducer(row, currentColumn),
              id: row.id,
            }),
            {}
          )
        ),
      }
    );
  };

  const validationHandlers = {
    [props.rowKey || 'row']: (formBody) =>
      !!formBody
        ? columns.reduce(
            (isValid, currentColumn) =>
              isValid &&
              (currentColumn.columnContentType.isRequired
                ? !!(formBody || {})[currentColumn.key]
                : true),
            true
          )
        : false,
    [props.tableKey || 'rows']: (formBody) =>
      !!formBody
        ? formBody.reduce(
            (isRowValid, currentRow) =>
              isRowValid &&
              columns.reduce((isValid, currentColumn) => {
                return (
                  isValid &&
                  (currentColumn.columnContentType.isRequired
                    ? !!(currentRow || {})[currentColumn.key]
                    : true)
                );
              }, true),
            true
          )
        : true,
  };

  const isEmptyValidators = {
    [props.rowKey || 'row']: (formState) => {
      const currentRow = formState[props.rowKey || 'row'];
      const containsData = columns.reduce(
        (cellEmptyFlag, currentColumn) =>
          cellEmptyFlag || (currentRow || {})[currentColumn.key] !== null,
        false
      );

      return !containsData;
    },
    [props.tableKey || 'rows']: (formState) => {
      const rows = formState[props.tableKey || 'rows'];
      const containsData =
        (rows || []).length > 0 &&
        (rows || []).reduce(
          (stateEmptyFlag, row) =>
            stateEmptyFlag ||
            columns.reduce(
              (cellEmptyFlag, currentColumn) =>
                cellEmptyFlag || (row || {})[currentColumn.key] !== null,
              false
            ),
          false
        );

      return !containsData;
    },
  };

  const deeplinkHandler = (deeplink, apiType, formBody) => {
    if (!!apiType && apiType !== 1 && apiType !== 4) {
      const isEmpty = (Object.keys(formBody || {}) || []).reduce(
        (isEmpty, currentField) => {
          return (
            isEmpty &&
            isEmptyValidators.hasOwnProperty(currentField) &&
            isEmptyValidators[currentField](formBody)
          );
        },
        true
      );

      if (isEmpty) {
        setClickedActionButton(-1);
        setClickedAggregateButton(-1);
        alert('Please add some data before submitting');
        return 0;
      }
    }

    if (!!apiType && apiType !== 1 && apiType !== 4) {
      const isDataValid = Object.keys(formBody || {}).reduce(
        (isValid, currentField) =>
          isValid &&
          validationHandlers.hasOwnProperty(currentField) &&
          validationHandlers[currentField]
            ? validationHandlers[currentField](formBody[currentField])
            : true,
        true
      );
      if (!isDataValid) {
        setClickedActionButton(-1);
        setClickedAggregateButton(-1);
        alert(
          "Please fill all the mandatory fields for all the rows \n - Mandatory fields are the ones with a '*' in the column title"
        );
        return 0;
      }
    }

    const processedFormBody = {
      ...formBody,
      [props.tableKey || 'rows']: (
        (formBody || {})[props.tableKey || 'rows'] || []
      ).map((row) => {
        columns.forEach((column) => {
          if (
            !column.columnContentType.isRequired &&
            row[column.key] === null
          ) {
            delete row[column.key];
          }
        });
        return row;
      }),
    };
    if (/(pushUrl)/.test(deeplink)) {
      (props.setDeepLink || (() => {}))(deeplink);
      SMDIalogControl.close();
      setClickedActionButton(-1);
      setClickedAggregateButton(-1);
    } else
      return handleDeeplink(
        deeplink,
        apiType,
        processedFormBody,
        {
          doneCallback: (refreshDeeplink) => {
            /(pushUrl)/.test(refreshDeeplink)
              ? (props.setDeepLink || (() => {}))(refreshDeeplink)
              : (props.fetchCards || refreshTable)(refreshDeeplink);
            SMDIalogControl.close();
            SMConfirmDialogControl.close();
          },
          cancelCallback: () => {},
          errorCallback: () => {},
          ...(props.miscHandlers || {}),
        },
        {
          columns,
          fileInputRef,
          refresh: (refreshDeeplink) => {
            if (/refreshPopup/.test(refreshDeeplink)) {
              props.setDialogDeeplink(
                refreshDeeplink.replace('/refreshPopup', '')
              );
            } else {
              SMDIalogControl.close();
              /(dialog|view|confirm|prompt)/.test(refreshDeeplink)
                ? props.setDeepLink(refreshDeeplink)
                : (props.fetchCards || refreshTable)(refreshDeeplink);
            }
          },
          ...(props.miscItems || {}),
        }
      ).then((response) => {
        setClickedActionButton(-1);
        setClickedAggregateButton(-1);
        if (response) {
          /refreshPopup/.test(response.refreshDeeplink)
            ? props.setDialogDeeplink(
                response.refreshDeeplink.replace('/refreshPopup', '')
              )
            : /(dialog|view|confirm|prompt)/.test(response.refreshDeeplink)
            ? props.setDeepLink(response.refreshDeeplink)
            : /(print)/.test(response.refreshDeeplink || '')
            ? clickToPrint(response.refreshDeeplink.replace('/print', ''))
            : props.fetchCards &&
              (response.refreshDeeplink ||
                (response.data && response.data.refreshDeeplink))
            ? props.fetchCards(
                response.refreshDeeplink ||
                  (response.data || {}).refreshDeeplink
              )
            : /^(http|https):\/\/(.+)/.test(
                response.refreshDeeplink ||
                  (response.data || {}).refreshDeeplink ||
                  ''
              )
            ? handleDeeplink(
                response.refreshDeeplink ||
                  (response.data || {}).refreshDeeplink
              )
            : props.onDone &&
              !/(rows)/.test(
                (
                  response.refreshDeeplink ||
                  (response.data || {}).refreshDeeplink ||
                  ''
                ).toLowerCase()
              ) &&
              !/(rows=true)/.test(
                (
                  response.refreshDeeplink ||
                  (response.data || {}).refreshDeeplink ||
                  ''
                ).toLowerCase()
              ) &&
              !/(rows\/true)/.test(
                (
                  response.refreshDeeplink ||
                  (response.data || {}).refreshDeeplink ||
                  ''
                ).toLowerCase()
              )
            ? (props.onDone || (() => {}))(
                response.refreshDeeplink ? response : response.data || {}
              )
            : fetchRows(
                response.refreshDeeplink ||
                  (response.data || {}).refreshDeeplink
              );

          (response.redirectLink ||
            (response.data && response.data.redirectLink)) &&
            handleDeeplink(
              response.redirectLink || (response.data || {}).redirectLink
            );
          return response;
        }
      });
  };

  const updatePseudoState = (key, value) => {
    // TODO find better readable names for args
    setPseudoFormState((currentPseudoFormState) => {
      return {
        ...currentPseudoFormState,
        [key]: value,
      };
    });
  };
  const updateFormState = (key, value) => {
    setFormState((currentFormState) => {
      return {
        ...currentFormState,
        [key]: value,
      };
    });
  };

  const handleRowChange = (rowId, newRowState, removalKeys) => {
    let rowFound = false;
    setPseudoFormState((currentPseudoFormState) => {
      let updatedRowState = [...(currentPseudoFormState.rows || [])];

      updatedRowState = updatedRowState.map((currentRow) => {
        if (
          (selected || []).length > 0
            ? selected.includes(currentRow.id)
            : currentRow.id === rowId
        ) {
          rowFound = true;
          (removalKeys || []).forEach((key) => {
            delete currentRow[key];
          });
          return { ...currentRow, ...newRowState };
        }
        return currentRow;
      });

      if (!rowFound) {
        updatedRowState = [
          ...updatedRowState,
          { ...(newRowState || {}), id: rowId },
        ];
      }

      return { ...currentPseudoFormState, rows: updatedRowState };
    });
  };

  const handlePaste = (rowOffset, key, values) => {
    const tempRows = rows;

    const newRows = values.map((value, index) => ({
      ...(tempRows[index + rowOffset] || blankRowGenerator()),
      [key]: { value },
      id:
        (tempRows[index + rowOffset] || {}).id ||
        `row-${index}-new=${index + rowOffset}`,
    }));

    SMPromptControl.open(
      'Paste options',
      <Typography>Please select how you want to paste the data</Typography>,
      [
        <Button
          color="primary"
          onClick={() => {
            let updatedRows = [...tempRows];
            updatedRows.splice(
              rowOffset + 1,
              0,
              ...(newRows || []).map((row, index) => ({
                [key]: row[key],
                id: `row-${index}-new=${index + rowOffset}`,
              }))
            );
            const newState = {
              rows: (updatedRows || []).map((row) => {
                const currentRowState = (
                  (pseudoFormState || {}).rows || []
                ).find((currentRow) => currentRow.id === row.id);
                return (columns || []).reduce(
                  (rowState, currentColumn) => ({
                    ...rowState,
                    ...cellStateReducer(row, currentColumn),
                    ...(key !== currentColumn.key
                      ? {
                          [currentColumn.key]: (currentRowState || {})[
                            currentColumn.key
                          ],
                        }
                      : {}),
                    id: row.id,
                  }),
                  {}
                );
              }),
            };
            setRows(updatedRows);
            refreshFormState(updatedRows, columns, newState);
            SMPromptControl.close();
          }}
        >
          Shift
        </Button>,
        <Button
          color="primary"
          onClick={() => {
            let updatedRows = [...tempRows];
            updatedRows.splice(
              rowOffset,
              (newRows || []).length,
              ...(newRows || [])
            );
            const newState = {
              rows: (updatedRows || []).map((row) => {
                const currentRowState = (
                  (pseudoFormState || {}).rows || []
                ).find((currentRow) => currentRow.id === row.id);
                return (columns || []).reduce(
                  (rowState, currentColumn) => ({
                    ...rowState,
                    ...cellStateReducer(row, currentColumn),
                    ...(key !== currentColumn.key
                      ? {
                          [currentColumn.key]: (currentRowState || {})[
                            currentColumn.key
                          ],
                        }
                      : {}),
                    id: row.id,
                  }),
                  {}
                );
              }),
            };
            setRows(updatedRows);
            refreshFormState(updatedRows, columns, newState);
            SMPromptControl.close();
          }}
        >
          Replace
        </Button>,
        <Button
          color="primary"
          onClick={() => {
            const updatedRows = [
              ...(tempRows || []),
              ...(newRows || []).map((row, index) => ({
                [key]: row[key],
                id: `row-${index}-new=${index + rowOffset}`,
              })),
            ];
            const newState = {
              rows: (updatedRows || []).map((row) => {
                const currentRowState = (
                  (pseudoFormState || {}).rows || []
                ).find((currentRow) => currentRow.id === row.id);
                return (columns || []).reduce(
                  (rowState, currentColumn) => ({
                    ...rowState,
                    ...cellStateReducer(row, currentColumn),
                    ...(key !== currentColumn.key
                      ? {
                          [currentColumn.key]: (currentRowState || {})[
                            currentColumn.key
                          ],
                        }
                      : {}),
                    id: row.id,
                  }),
                  {}
                );
              }),
            };
            setRows(updatedRows);
            refreshFormState(updatedRows, columns, newState);
            SMPromptControl.close();
          }}
        >
          Add to the end
        </Button>,
      ]
    );
  };

  const addRow = () => {
    const newRow = blankRowGenerator((rows || []).length + 1);
    setRows([...rows, newRow]);
    // setPseudoFormState({
    //   rows: [
    //     ...pseudoFormState.rows,
    //     (columns || []).reduce(
    //       (rowState, currentColumn) => ({
    //         ...rowState,
    //         ...cellStateReducer(newRow, currentColumn),
    //         id: newRow.id,
    //       }),
    //       {}
    //     ),
    //   ],
    // });
    setAddingRow(true);
    setNewRowIndex((rows || []).length + 1);
  };

  const cancelAddRow = () => {
    setRows((rows || []).filter((row) => row.id !== newRowIndex));
    setPseudoFormState({
      ['rows']: (pseudoFormState['rows'] || []).filter(
        (row) => row.id !== newRowIndex
      ),
    });
    setAddingRow(false);
    setNewRowIndex(null);
  };

  const dialogActionFunctionality = (response) => {
    response.refreshDeeplink && props.fetchCards(response.refreshDeeplink);
    response.id && setNewRowId(response.id);
    setDialogDeeplink(undefined);
    setSelected([]);
  };

  const deleteDialogActionFunctionality = (response) => {
    response.refreshDeeplink && props.fetchCards(response.refreshDeeplink);
    setDeleteDeeplink(undefined);
    setSelected([]);
  };

  const csvHeaders = columns.map((column) => ({
    label: column.title,
    key: column.key,
  }));
  const csvEntities =
    rows &&
    rows.map((row, index) =>
      columns.reduce((newEntity, column) => {
        let colValue =
          column.columnContentType.columnType == 1
            ? (
                columns.find((col) => col.key == column.key).selection || []
              ).find((option) => option.id == (row[column.key] || {}).value)
            : null;
        newEntity[column.key] =
          column.columnContentType.columnType == 1
            ? !!colValue
              ? colValue.title
              : ''
            : row[column.key]
            ? row[column.key].value
            : '';
        return newEntity;
      }, {})
    );

  React.useEffect(() => {
    if (get(pseudoFormState, 'rows', []).length > (rows || []).length) {
      const tempPseudoState = get(pseudoFormState, 'rows', []);
      (tempPseudoState || []).splice(
        (rows || []).length - 1,
        tempPseudoState.length - (rows || []).length
      );
      updatePseudoState('rows', tempPseudoState);
    }
  }, [rows, pseudoFormState]);

  React.useEffect(() => {
    if (props.checkProgress && progressStatusDeepLink) {
      const interval = setInterval(() => {
        handleDeeplink(progressStatusDeepLink)
          .then((data) => {
            if (data.done) {
              setProgressBar(null);
              setLoading(true);
              refreshTable(props.progressSuccessDeepLink);
              clearInterval(interval);
            } else {
              setProgressBar(data.progress);
            }
          })
          .catch(console.log);
      }, 3000);
    }
  }, [props.checkProgress, progressStatusDeepLink]);

  React.useEffect(() => {
    (props.recordChildState || (() => {}))(pseudoFormState);
    return () => {
      (props.recordChildState || (() => {}))({});
    };
  }, [pseudoFormState]);

  React.useEffect(() => {
    props.rows && setRows(props.rows);
    props.columns && setColumns(props.columns);
    setSelected([]);
    refreshFormState(
      props.rows,
      props.columns,
      (props.stateParentCopy || {}).rows ? props.stateParentCopy : undefined
    );
  }, [props.rows, props.columns]);

  React.useEffect(() => {
    props.numberOfPages && setNumberOfPages(props.numberOfPages);
  }, [props.numberOfPages]);

  React.useEffect(() => {
    props.filter &&
      props.filter.selected &&
      props.filter.selected != selectedFilters[props.filter.key] &&
      setSelectedFilters({ [props.filter.key]: props.filter.selected });
  }, [props.filter]);
  React.useEffect(() => {
    if (props.filters) {
      let currentFilters = {};
      props.filters.forEach((filter) => {
        if (!!filter.selected && filter.selected != selectedFilters[filter.key])
          currentFilters[filter.key] = filter.selected;
      });
      Object.keys(currentFilters).length > 0 &&
        setSelectedFilters(currentFilters);
    }
  }, [props.filters]);

  React.useEffect(() => {
    let query = `query${
      currentPage !== undefined && numberOfPages ? `/page/${currentPage}` : ''
    }${searchString ? `/search/${searchString}` : ''}${Object.keys(
      selectedFilters || {}
    ).reduce(
      (queryString, currentFilter) =>
        queryString + `/${currentFilter}/${selectedFilters[currentFilter]}`,
      ''
    )}`;
    if (props.baseDeepLink && props.baseDeepLink.includes('?'))
      query = query.replace(/query\/(.+)/, (m, query) =>
        query
          .split(/\//)
          .reduce(
            (qs, val, index) =>
              `${qs}${index % 2 ? '=' : index ? '&' : ''}${val}`,
            '&'
          )
      );
    aggregateEnabled(props) &&
      refresh &&
      refreshTable(
        `/${props.baseDeepLink}${
          searchString ||
          (currentPage !== undefined && numberOfPages) ||
          Object.keys(selectedFilters).length > 0
            ? query
            : ''
        }`
      );

    !refresh && setRefresh(true);
  }, [selectedFilters, searchString, currentPage, props.baseDeepLink]);

  React.useEffect(() => {
    newRowId && setTimeout(() => setStyle({}), 3000);
  }, [newRowId]);

  React.useEffect(() => {
    let masquerader = pseudoFormState.rows;
    masquerader = masquerader.filter((row) => selected.includes(row.id));
    updateFormState('rows', masquerader);
  }, [pseudoFormState, selected]);

  React.useEffect(() => {
    progressBar && progressBar.loading && setResponseAwaited(true);
    progressBar && !progressBar.loading && setResponseAwaited(false);
  }, [progressBar]);

  const resetFields = () => {
    setSearchString('');
    setSelectedFilters({});
  };

  return (
    <div style={{ padding: '0 16px' }}>
      <TableInfoContainer tableInfo={props.tableInfo} />
      <EnhancedTableToolbar
        responseAwaited={responseAwaited}
        numSelected={selected.length}
        aggregateActions={props.aggregateActions}
        tableActions={props.tableActions}
        handleDeepLink={handleDeeplink}
        filter={props.filter}
        formState={formState}
        tableKey={props.tableKey}
        pseudoFormState={pseudoFormState}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        searchString={searchString}
        setSearchString={setSearchString}
        deeplinkHandler={deeplinkHandler}
        searchEnabled={props.searchEnabled || false}
        setMessage={props.setMessage}
        resetFields={resetFields}
        addRowEnabled={props.addRowEnabled}
        addingRow={addingRow}
        addRow={addRow}
        setAddingRow={setAddingRow}
        cancelAddRow={cancelAddRow}
        refreshButton={props.refreshButton}
        fetchRows={fetchRows}
        refreshTable={refreshTable}
        exportTable={props.exportTable}
        csvHeaders={csvHeaders}
        csvEntities={csvEntities}
        progressBar={progressBar}
        clickedAggregateButton={clickedAggregateButton}
        setClickedAggregateButton={setClickedAggregateButton}
        clickedActionButton={clickedActionButton}
        setClickedActionButton={setClickedActionButton}
      />
      <TableFiltersAndSearchContainer
        filters={props.filters}
        responseAwaited={responseAwaited}
        setResponseAwaited={setResponseAwaited}
        filter={props.filter}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        numSelected={selected.length}
        searchEnabled={props.searchEnabled || false}
        searchString={searchString}
        setSearchString={setSearchString}
        resetFields={resetFields}
        handleFormUpdate={updateFormState}
        formFields={props.formFields}
      />
      <TableFilterContainer
        filters={props.filters}
        responseAwaited={responseAwaited}
        setResponseAwaited={setResponseAwaited}
        filter={props.filter}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        searchString={searchString}
        setSearchString={setSearchString}
      />
      {loading ? (
        <div style={{ width: '100%', height: '50vh' }}>
          <LoadingSheet />
        </div>
      ) : (
        <div style={{ width: '100%' }}>
          <input
            type="file"
            accept=".xlsx, .csv, .xls"
            style={{ display: 'none' }}
            ref={fileInputRef}
          />
          {/* <EnhancedTableToolbar
            numSelected={selected.length}
            aggregateActions={props.aggregateActions}
            tableActions={props.tableActions}
            handleDeepLink={handleDeeplink}
            filter={props.filter}
            formState={formState}
            tableKey={props.tableKey}
            pseudoFormState={pseudoFormState}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            searchString={searchString}
            setSearchString={setSearchString}
            deeplinkHandler={deeplinkHandler}
            searchEnabled={props.searchEnabled || false}
            setMessage={props.setMessage}
            resetFields={resetFields}
            addRowEnabled={props.addRowEnabled}
            addingRow={addingRow}
            addRow={addRow}
            setAddingRow={setAddingRow}
            cancelAddRow={cancelAddRow}
            refreshButton={props.refreshButton}
            fetchRows={fetchRows}
            refreshTable={refreshTable}
            exportTable={props.exportTable}
            csvHeaders={csvHeaders}
            csvEntities={csvEntities}
            progressBar={progressBar}
            clickedAggregateButton={clickedAggregateButton}
            setClickedAggregateButton={setClickedAggregateButton}
            clickedActionButton={clickedActionButton}
            setClickedActionButton={setClickedActionButton}
          /> */}
          <div
            style={{
              width: '100%',
              backgroundColor: '#ffffff',
              borderRadius: 7,
              paddingBottom: 10,
            }}
          >
            <TableContainer
              elevation={2}
              className={classes.container}
              style={{
                height: props.insideDialog
                  ? props.isLarge
                    ? '68.5vh'
                    : '53vh'
                  : props.tableSize == 'small'
                  ? '58vh'
                  : props.tableSize == 'large'
                  ? '68vh'
                  : props.tableSize == 'xlarge'
                  ? '90vh'
                  : '68vh',
              }}
            >
              <Table
                className={classes.table}
                aria-label="simple table"
                stickyHeader={true}
                width={100}
                style={{
                  borderCollapse: 'collapse',
                  tableLayout: 'auto',
                }}
              >
                <EnhancedTableHead
                  style={{
                    backgroundColor: '#ffffff',
                    position: 'sticky',
                    top: '0px',
                  }}
                  numSelected={selected.length}
                  onSelectAllClick={handleSelectAllClick}
                  rowCount={(rows || []).length}
                  enableMultipleSelect={props.enableMultipleSelect}
                  columns={columns}
                />
                <TableBody
                  style={{
                    // border: '1px solid #e0e0e0',
                    position: 'relative',
                  }}
                >
                  {!rows || (rows || []).length === 0 ? (
                    <TableErrorView
                      colSpan={(props.columns || []).length + 2}
                      errorMessage={props.emptyTableMessage || 'No data'}
                    />
                  ) : (
                    (rows || []).map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      return (
                        <ExtendedTableRow
                          row={row}
                          columns={columns}
                          isItemSelected={isItemSelected}
                          newRowId={newRowId}
                          totalRows={(rows || []).length}
                          enableMultipleSelect={props.enableMultipleSelect}
                          handleClick={handleClick}
                          lastUpdated={lastUpdated}
                          index={index}
                          handlePaste={(key, values) =>
                            handlePaste(index, key, values)
                          }
                          pseudoFormState={pseudoFormState}
                          handleRowChange={handleRowChange}
                          rightSideBar={props.rightSideBar}
                          preview={props.preview}
                          rows={[...(rows || [])]}
                          style={style}
                          handleDeeplink={deeplinkHandler}
                          handleDeepLinkFunction={handleDeeplink}
                          baseDeepLink={props.baseDeepLink}
                          rowKey={props.rowKey}
                          fetchRows={fetchRows}
                          setMessage={props.setMessage}
                          selected={selected}
                          addingRow={addingRow}
                          currentPage={currentPage}
                          rowsPerPage={props.rowsPerPage}
                        />
                        //Row moved to a standalone component
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <div
              className={classes.tableFooter}
              style={{ padding: props.insideDialog ? 0 : '20px 0px 10px 0px' }}
            >
              <Box>
                {props.footerActions &&
                  props.footerActions.map((button) => (
                    <Button
                      className={classes.tableFooterActionButton}
                      onClick={() => deeplinkHandler(button.deep_link)}
                    >
                      <DynamicIcon
                        iconId={button.iconId}
                        style={{
                          marginRight: 10,
                          color: '#909090',
                          fontSize: 20,
                        }}
                      />
                      {button.name}
                    </Button>
                  ))}
              </Box>
              <div className={classes.paginationContainer}>
                {numberOfPages ? (
                  <Pagination
                    color={'primary'}
                    page={currentPage}
                    shape={'rounded'}
                    variant={'outlined'}
                    count={numberOfPages}
                    onChange={(e, pageIndex) => setPage(pageIndex)}
                  />
                ) : null}
              </div>
            </div>
          </div>
          {dialogDeeplink && (
            <DynamicDialogView
              setMessage={props.setMessage}
              deeplink={dialogDeeplink}
              onClose={() => setDialogDeeplink(null)}
              dialogActionFunctionality={dialogActionFunctionality}
            />
          )}
          {deleteDeeplink && (
            <DynamicDeleteDialogView
              selected={selected}
              deleteDeeplink={`${deleteDeeplink}/${selected[0]}`}
              onClose={() => setDeleteDeeplink(null)}
              handleDeeplink={handleDeeplink}
              dialogActionFunctionality={deleteDialogActionFunctionality}
            />
          )}
        </div>
      )}
    </div>
  );
}
